// import RepositoryFactory from "@/apis";
// const google = RepositoryFactory.google;
import google from "../../apis/google";

export default {
  getAuthUrl({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await google.getAuthUrl(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getToken({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await google.getToken(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
